export const SEMANAS_POR_MES = 4.345;
export const DIAS_POR_MES = 30;

export interface EquilibrioInputs {
  precio: number;
  costoVariable: number;
  costosFijosMensuales: number;
}

export interface EquilibrioDerivado {
  contribucionPaq: number;
  contribucionPct: number;
  paquetesEquilibrioMes: number | null;
  paquetesEquilibrioSemana: number | null;
  paquetesEquilibrioDia: number | null;
}

export function derivarEquilibrio({
  precio,
  costoVariable,
  costosFijosMensuales,
}: EquilibrioInputs): EquilibrioDerivado {
  const contribucionPaq = precio - costoVariable;
  const contribucionPct = precio > 0 ? contribucionPaq / precio : 0;
  if (contribucionPaq <= 0) {
    return {
      contribucionPaq,
      contribucionPct,
      paquetesEquilibrioMes: null,
      paquetesEquilibrioSemana: null,
      paquetesEquilibrioDia: null,
    };
  }
  const mes = Math.ceil(costosFijosMensuales / contribucionPaq);
  return {
    contribucionPaq,
    contribucionPct,
    paquetesEquilibrioMes: mes,
    paquetesEquilibrioSemana: Math.ceil(mes / SEMANAS_POR_MES),
    paquetesEquilibrioDia: Math.ceil(mes / DIAS_POR_MES),
  };
}

export function margenSeguridadPct(
  estimadoMes: number,
  equilibrioMes: number | null,
): number | null {
  if (equilibrioMes === null || equilibrioMes <= 0 || estimadoMes <= 0) return null;
  return (estimadoMes - equilibrioMes) / estimadoMes;
}
